/* eslint-disable camelcase */
import { fromJS } from 'immutable';
import * as actions from './actionTypes';
import { getErrorCode, getErrorMessage } from '../../containers/Error';
import * as types from '../../utils/constants/claimStatusTypes';

export const stateKey = 'ClaimsStore';

const initialState = fromJS({
  getClaims: {
    loading: null,
    data: [],
    error: { error: false, code: null, message: null, type: null, state: 'claims' },
  },
  getGWClaims: {
    loading: null,
    data: [],
    error: { error: false, code: null, message: null, type: null, state: 'claims' },
  },
  createClaim: {
    loading: false,
    data: null,
    error: { error: false, code: null, message: null, type: null, state: 'claims' },
  },
  createShellClaim: {
    loading: false,
    data: null,
    error: { error: false, code: null, message: null, type: null, state: 'claims' },
    duplicated: false,
  },
  updateClaim: {
    loading: false,
    data: {},
    error: { error: false, code: null, message: null, type: null, state: 'claims' },
  },
  submitClaim: {
    loading: false,
    data: {},
    error: { error: false, code: null, message: null, type: null, state: 'claims' },
  },
});

function claimsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_CLAIMS:
      return state
        .setIn(['getClaims', 'loading'], true);

    case actions.GET_CLAIMS_SUCCESS:
      return state
        .setIn(['getClaims', 'loading'], false)
        .setIn(['getClaims', 'data'], action.payload.claims);

    case actions.GET_CLAIMS_FAILED:
      return state
        .setIn(['getClaims', 'loading'], false)
        .setIn(['getClaims', 'error', 'error'], true)
        .setIn(['getClaims', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['getClaims', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['getClaims', 'error', 'type'], action.type);

    case actions.GET_GW_CLAIMS:
      return state
        .setIn(['getGWClaims', 'loading'], true);

    case actions.GET_GW_CLAIMS_SUCCESS:
      return state
        .setIn(['getGWClaims', 'loading'], false)
        .setIn(['getGWClaims', 'data'], action.payload.gwClaims);

    case actions.GET_GW_CLAIMS_FAILED:
      return state
        .setIn(['getGWClaims', 'loading'], false)
        .setIn(['getGWClaims', 'error', 'error'], true)
        .setIn(['getGWClaims', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['getGWClaims', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['getGWClaims', 'error', 'type'], action.type);

    case actions.CREATE_CLAIM:
      return state
        .setIn(['createClaim', 'loading'], true);

    case actions.CREATE_CLAIM_SUCCESS:
      return state
        .setIn(['createClaim', 'loading'], false)
        .setIn(['createClaim', 'data'], action.payload.createdClaim.claimId)
        .updateIn(['getClaims', 'data'], (arr) => arr.concat([action.payload.createdClaim]));

    case actions.CREATE_CLAIM_FAILED:
      return state
        .setIn(['createClaim', 'loading'], false)
        .setIn(['createClaim', 'error', 'error'], true)
        .setIn(['createClaim', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['createClaim', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['createClaim', 'error', 'type'], action.type);

    case actions.UPDATE_CLAIM:
      return state
        .setIn(['updateClaim', 'loading'], true);

    case actions.UPDATE_CLAIM_SUCCESS:
      const { claimId,
        digitalFNOLStatus,
        claimServices,
        cdsClaimNumber,
        audatargetClaimId,
        leaveForm } = action.payload;

      const { submittedData } = action.payload;
      const claimIndex = state.get('getClaims').get('data').findIndex((o) => o.claimId === claimId);

      return state
        .setIn(['updateClaim', 'loading'], false)
        .setIn(['updateClaim', 'data'], leaveForm ? {} : submittedData)
        .setIn(['getClaims', 'data', claimIndex, 'digitalFNOLStatus'], digitalFNOLStatus)
        .setIn(['getClaims', 'data', claimIndex, 'cdsClaimNumber'], cdsClaimNumber)
        .setIn(['getClaims', 'data', claimIndex, 'submittedData'], submittedData)
        .setIn(['getClaims', 'data', claimIndex, 'claimServices'], claimServices)
        .setIn(['getClaims', 'data', claimIndex, 'audatargetClaimId'], audatargetClaimId);

    case actions.UPDATE_CLAIM_FAILED:
      return state
        .setIn(['updateClaim', 'loading'], false)
        .setIn(['updateClaim', 'error', 'error'], true)
        .setIn(['updateClaim', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['updateClaim', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['updateClaim', 'error', 'type'], action.type);

    case actions.CREATE_SHELL_CLAIM:
      return state
        .setIn(['createShellClaim', 'loading'], true);

    case actions.CREATE_SHELL_CLAIM_SUCCESS:
      const index = state.get('getClaims').get('data').findIndex((o) => o.claimId === action.payload.claimId);
      return state
        .setIn(['createShellClaim', 'loading'], false)
        .setIn(['getClaims', 'data', index, 'gwClaimId'], action.payload.gwClaimId)
        .setIn(['getClaims', 'data', index, 'gwClaimNumber'], action.payload.gwClaimNumber)
        .setIn(['getClaims', 'data', index, 'policyAddress'], action.payload.policyAddress);

    case actions.CREATE_SHELL_CLAIM_FAILED:
      return state
        .setIn(['createShellClaim', 'loading'], false)
        .setIn(['createShellClaim', 'error', 'error'], true)
        .setIn(['createShellClaim', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['createShellClaim', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['createShellClaim', 'error', 'type'], action.type);

    case actions.CREATE_SHELL_CLAIM_DUPLICATED:
      return state
        .setIn(['createShellClaim', 'loading'], false)
        .setIn(['createShellClaim', 'duplicated'], true);

    case actions.SUBMIT_CLAIM:
      return state
        .setIn(['submitClaim', 'loading'], true);

    case actions.SUBMIT_CLAIM_SUCCESS:
      const i = state.get('getClaims').get('data').findIndex((o) => o.claimId === action.payload.claimId);
      return state
        .setIn(['submitClaim', 'loading'], false)
        .setIn(['submitClaim', 'data', 'claimId'], action.payload.claimId)
        .setIn(['getClaims', 'data', i, 'digitalFNOLStatus'], types.CLAIM_STATUS_SUBMITTED);

    case actions.SUBMIT_CLAIM_FAILED:
      return state
        .setIn(['submitClaim', 'loading'], false)
        .setIn(['submitClaim', 'error', 'error'], true)
        .setIn(['submitClaim', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['submitClaim', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['submitClaim', 'error', 'type'], action.type);

    case actions.CLEAR_ERRORS:
      return state
        .setIn(['getClaims', 'error', 'error'], false)
        .setIn(['getGWClaims', 'error', 'error'], false)
        .setIn(['createClaim', 'error', 'error'], false)
        .setIn(['createShellClaim', 'error', 'error'], false)
        .setIn(['updateClaim', 'error', 'error'], false)
        .setIn(['submitClaim', 'error', 'error'], false);

    case actions.CLEAR_SHELL_CLAIM_DUPLICATED:
      return state
        .setIn(['createShellClaim', 'duplicated'], false);

    default:
      return state;
  }
}

export default claimsReducer;
